import React, { FC } from 'react'
import { Helmet } from 'react-helmet'
import styled from 'styled-components'
import { ComponentRawHTML } from '../../../models/components/rawHTML'

type Props = {
  data: ComponentRawHTML | null
}

const RawHTMLWrapper = styled.section<{ $css: string }>`
  ${({ $css }) => $css}
`

const RawHTML: FC<Props> = ({ data }) => {
  if (!data) return null
  const html =
    typeof data.componentHtml === 'string' ? data.componentHtml : data.componentHtml?.componentHtml
  const css =
    typeof data.componentCss === 'string' ? data.componentCss : data.componentCss?.componentCss
  const js = typeof data.componentJs === 'string' ? data.componentJs : data.componentJs?.componentJs

  return (
    <RawHTMLWrapper $css={css} data-cy="rawHTML">
      {js && (
        <Helmet>
          <script>{js}</script>
        </Helmet>
      )}

      <div
        dangerouslySetInnerHTML={{
          __html: html,
        }}
      />
    </RawHTMLWrapper>
  )
}

export default RawHTML
